import React, { ReactNode } from 'react';

import ConfirmationPopupProviderContext from './contexts/confirmation-popup-provider-context';
import useConfirmationPopupProviderState from './states/confirmation-popup-provider-state';

type Props = {
  children: ReactNode;
};

const ConfirmationPopupProvider = ({ children }: Readonly<Props>): React.JSX.Element => {
  return (
    <ConfirmationPopupProviderContext.Provider value={useConfirmationPopupProviderState()}>
      {children}
    </ConfirmationPopupProviderContext.Provider>
  );
};

export default ConfirmationPopupProvider;
